import { render, staticRenderFns } from "./SummaryModal.vue?vue&type=template&id=0940839f&scoped=true"
import script from "./SummaryModal.vue?vue&type=script&lang=js"
export * from "./SummaryModal.vue?vue&type=script&lang=js"
import style0 from "./SummaryModal.vue?vue&type=style&index=0&id=0940839f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0940839f",
  null
  
)

export default component.exports